module.exports = __webpack_public_path__ + "static/img/loader.0a55a0f.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/loader.gif
// module id = 166
// module chunks = 180